import BaseAbility from 'umg-ember-backend/abilities/base';

export default class NewsletterFormAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('artist');
  }
}
